<template>
	<vx-card class="site-edit-item w-full">
		<div class="site-edit-item__body">
			<vs-tabs>
				<vs-tab class="site-edit-item__tab" :label="$t('sitesSettings')">
					<SiteSettings
						:site="site"
						:validate="validate"
					/>
				</vs-tab>

				<vs-tab class="site-edit-item__tab" :label="$t('basicPrices')">
					<SitePrices
						:prices="filteredPrices"
						:works="works"
						:levels="levels"
					/>
				</vs-tab>

				<vs-tab class="site-edit-item__tab" :label="$t('workTypesVisibility')">
					<SiteWorksVisibility
						:modelWorks="site.enable_work_types"
						:works="works"
						:levels="levels"
					/>
				</vs-tab>

				<vs-tab class="site-edit-item__tab" :label="$t('invoicesData')">
					<SiteInvoiceInfo
						:model="site"
						:validate="validate"
					/>
				</vs-tab>

				<vs-tab class="site-edit-item__tab" :label="$t('autoAnswers')">
					<SiteAutoAnswers
						:model="site"
						:validate="validate"
					/>
				</vs-tab>

				<vs-tab class="site-edit-item__tab" :label="$t('deletionReminders')">
					<SiteAutoAnswers
						:model="site"
						:validate="validate"
						deletion-reminders-only
					/>
				</vs-tab>

				<vs-tab class="site-edit-item__tab" :label="$t('externalEmails')">
					<SiteExternalEmails
						:model="site"
						:validate="validate"
					/>
				</vs-tab>

				<vs-tab class="site-edit-item__tab" :label="$t('templateAnswers')">
					<SiteTemplateAnswers
						:template-answers.sync="templateAnswers"
            @search-templates="searchTemplates"
					/>
				</vs-tab>
			</vs-tabs>
		</div>
		<div class="site-edit-item__controls vx-row mt-3 flex justify-end">
			<div class="vx-col mt-2">
				<vs-button
					@click="save"
				>{{ $t('save') }}</vs-button>
			</div>
			<div class="vx-col mt-2">
				<vs-custom-button
					@click="$router.back()"
					type="border"
					color="warning"
				>{{ $t('cancel') }}</vs-custom-button>
			</div>
		</div>
	</vx-card>
</template>

<script>
import SiteAutoAnswers from "@/views/Sites/SiteAutoAnswers";
import SiteTemplateAnswers from "@/views/Sites/SiteTemplateAnswers";
import SiteSettings from "@/views/Sites/SiteSettings";
import SitePrices from "@/views/Sites/SitePrices";
import SiteWorksVisibility from "@/views/Sites/SiteWorksVisibility";
import SiteInvoiceInfo from "@/views/Sites/SiteInvoiceInfo";
import SiteExternalEmails from '@/views/Sites/SiteExternalEmails.vue';
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "SiteItem",

	mixins: [databaseManager, notifier],

	components: {
		SiteAutoAnswers,
    SiteTemplateAnswers,
		SiteSettings,
		SitePrices,
		SiteWorksVisibility,
		SiteInvoiceInfo,
		SiteExternalEmails
	},

	data() {
		return {
			site: {},
			works: [],
			levels: [],
			filteredPrices: {},
			validate: false,
		};
	},

	computed: {
		mode() {
			return this.$route.params.mode;
		},

    siteId() {
			return this.$route.params.id;
		},

    templateAnswers: {
      get() {
        return this.site.chat_template_messages || []
      },
      set(val) {
        this.site.chat_template_messages = val
      }
    }
	},

	methods: {
    async searchTemplates(query) {
      await this.updateSite(query)
    },

		getEmptyPrices() {
			let prices = {};

			for(let y = 0; y < this.works.length; y++) {
				const workId = this.works[y].id;
				prices[workId] = [];

				for(let i = 0; i < this.levels.length; i++) {
					const levelId = this.levels[i].id;
					prices[workId].push({
						quality_level_id: levelId,
						price: 0,
						price_first_four_page: workId === 9 ? 0 : null
					});
				}
			}

			return prices;
		},

		fillWorks() {
			for(let i = 0; i < this.works.length; i++) {
				const workId = this.works[i].id;

				let workIndex = this.site.enable_work_types
					.findIndex(item => item.work_type_id === workId);

				if (workIndex === -1) {
					this.site.enable_work_types.push({
						work_type_id: workId,
						is_enabled_for_junior: false,
						is_enabled_for_middle: false,
						is_enabled_for_senior: false,
						is_price_native: false,
						native_price: 0,
					});
				}

			}
		},
		fillSite() {
			this.site = {
				uid: "",
				name: "",
				email: "",
				email_password: "",
				phone: "",
				logo: "",
				commission_manager_percent: "",
				theme_color_main: null,
				theme_color_secondary: null,
				invoice_logo: "",
				about_text: "",
				terms_text: "",
				prices: [],
				enable_work_types: [],
				external_emails: [],
			};
		},
		filterPrices() {
			const filtered = this.getEmptyPrices();

        for(let price of this.site.prices) {
          try {
            const workId = price.work_type_id;

            const qualityLevelIndex = price.quality_level_id;
            const work = filtered[workId] ? filtered[workId].find(item => item.quality_level_id === qualityLevelIndex) : undefined

            if(work === undefined) continue;

            work.price = price.price;

            if(price.price_first_four_page) {
              work.price_first_four_page = price.price_first_four_page;
            }
          } catch (err) {
            console.error(err);
          }
        }

			this.filteredPrices = filtered;
			return filtered;
		},
		transformWorkType() {
			let output = {};

			for(let item of this.site.enable_work_types) {
				output[item.work_type_id] = {};
				output[item.work_type_id][1] = [+item.is_enabled_for_junior, +item.junior_price];
				output[item.work_type_id][2] = [+item.is_enabled_for_middle, +item.middle_price];
				output[item.work_type_id][3] = [+item.is_enabled_for_senior, +item.senior_price];
				output[item.work_type_id]['4'] = [+item.is_price_native, +item.native_price];
			}

			return output;
		},
		getInvoiceLogoUrl(fullUrl) {
			let httpText = "https://";
			let start = 0;
			let httpIndex = fullUrl.indexOf(httpText);

			if(httpIndex !== -1) start = httpText.length;

			start = fullUrl.indexOf("/", start);
			return fullUrl.substr(start);
		},
		async save() {
			this.validate = true;

			try {
				const data = Object.assign({}, this.site);
				data.invoice_logo = this.getInvoiceLogoUrl(data.invoice_logo);
				data.prices = this.filteredPrices;
				data.enable_work_types = this.transformWorkType();

				if(this.mode === "edit") {
					await this.dbUpdateWebsite(this.site.id, data);
					this.notifySuccess(this.$t('changesIsSavedSuccessfully'));
				} else if(this.mode === "create") {
					await this.dbCreateWebsite(data);
					this.notifySuccess(this.$t('siteWasCreatedSuccessfully'));
				}

				this.$router.back();

			} catch(e) {
				this.notifyError(e.message);
			}
		},
		async updateSite(query = '') {
			try {
				this.site = await this.dbViewWebsite(this.siteId, query);

			} catch(e) {
				this.notifyError(e.message);
			}
		}
	},
	async mounted() {
		try {
			if(this.mode === "edit") {
				await this.updateSite();
			} else if(this.mode === "create") {
				this.fillSite();
			}

			this.levels = (await this.$http.get("/settings/get-quality-levels")).data.data;
			this.works = (await this.$http.get("/settings/get-work-types")).data.data;

			this.filterPrices();
			this.fillWorks();

		} catch(e) {
			this.notifyError(e.message);
		}
	}
};
</script>

<style lang="scss" scoped>
.site-edit-item {
	&__tab {
		margin-top: 15px;
	}
}
</style>
